export const validateMobileNumber = (mobileNumber: string, ruleOverwrite: string[] | string | null = null): boolean => {
    let regex;
    if (Array.isArray(ruleOverwrite)) {
        regex = new RegExp(ruleOverwrite[0] || '.', ruleOverwrite[1] || '');
    } else if (typeof ruleOverwrite === 'string') {
        regex = new RegExp(ruleOverwrite);
    } else {
        regex = /^\+?[0-9]{6,15}$/;
    }
    return regex.test(mobileNumber);
};

export const validateEmail = (email: string, ruleOverwrite: string[] | string | null = null): boolean => {
    let regex;
    if (Array.isArray(ruleOverwrite)) {
        regex = new RegExp(ruleOverwrite[0] || '.', ruleOverwrite[1] || '');
    } else if (typeof ruleOverwrite === 'string') {
        regex = new RegExp(ruleOverwrite);
    } else {
        regex = /^[\w-.]+@([\w-]+\.)+[a-zA-z]{2,5}$/;
    }
    return regex.test(email);
};

export const validateLandline = (landline: string, ruleOverwrite: string[] | string | null = null): boolean => {
    let regex;
    if (Array.isArray(ruleOverwrite)) {
        regex = new RegExp(ruleOverwrite[0] || '.', ruleOverwrite[1] || '');
    } else if (typeof ruleOverwrite === 'string') {
        regex = new RegExp(ruleOverwrite);
    } else {
        regex = /^\+?[0-9]{6,15}$/;
    }
    return regex.test(landline);
};

export const validUrl = (url: string): boolean => {
    try {
        if (!url.startsWith('http')) {
            return false;
        }
        new URL(url);
        return true;
    } catch (err) {
        return false;
    }
};

export const validatePassword = (password: string): boolean => {
    const regex = /^[\d\D]{6,20}$/;
    return regex.test(password);
};

export const isEmpty = (value: any): boolean => {
    if (Array.isArray(value)) {
        // Check if array is empty
        return value.length === 0;
    } else if (value && typeof value === 'object' && value.constructor === Object) {
        // Check if object is empty
        return Object.keys(value).length === 0;
    } else if (typeof value === 'string') {
        // Check if string is empty
        return value.trim().length === 0;
    }

    return false; // If it's neither an array nor an object, return false
};
